import React from "react";
import {BrandName} from "../../../constants";
import {Paragraph, Underline} from "../TermsText";

const ChallengePrizesSection = () => {
  return (
    <>
      <Paragraph>
        <Underline>{"CHALLENGE PRIZES AND PROMOTIONS."}</Underline>{" Challenges offered are challenges of skill. Winners are determined by the objective criteria described in the Challenge deadline, roster, Rules, scoring, and any other applicable documentation associated with the Challenge. From all entries received for each Challenge, winners are determined by the individuals who use their skill and knowledge of relevant sports information and real money games rules to accumulate the most points according to the corresponding scoring rules. The Website, Applications and Challenges may not be used for any form of illicit gambling."}
      </Paragraph>

      <Paragraph>
        {"Guaranteed prizes are offered in connection with some of the Challenges offered. Each Challenge or promotion is governed by its own set of official rules. We encourage you to read such Challenge and promotions Rules before participating."}
      </Paragraph>

      <Paragraph>
        <Underline>{"TOURNAMENTS."}</Underline>{" "}{BrandName}{" offers Tournaments wherein players have the opportunity to win all or part of a Prize Pool. The details for the Tournaments are in the Tournament Overview, and include Timing, Entry Fee (or sponsored) and Payouts. Tournaments Entries can be entered with Withdrawable Funds (not Free Play) or the Prize Pool can be funded by a Third Party."}
      </Paragraph>

      <Paragraph>
        <Underline>{"New Player Promotion."}</Underline>{" New players receive “10 Free Shots” which are the equivalent of 10 Challenges with a $3 Challenge Fee, without deposit required. The results of each challenge during the “10 Free Shots” will be accumulated into Free Play with a 1x Turnover requirement. In the case that a New Player does not earn at least $10, the New Player will receive $10 in Free Play after the completion of their 10th Challenge"}
      </Paragraph>
    </>
  );
};

export default React.memo(ChallengePrizesSection);
